<script>
import TwCard from '@/components/generic/tw-card.vue'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import FundraiserPagePublishButton from '@/components/fundraiser-pages/fundraiser-page-publish-button.vue'
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'
import { useAuthStore } from '@/stores/auth.js'
import TwBadge from '@/components/generic/tw-badge.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'

export default {
  name: 'FundraiserPageTopHeader',
  components: { TwButton, TwBadge, FundraiserPagePublishButton, TwContainer, TwTransitionContainer, TwCard },
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentUser() {
      return useAuthStore().currentUser
    },
    fundraiserPageEditableByCurrentUser(){
      return !!(this.fundraiserPage.published && this.currentUser && (this.currentUser.id === this.fundraiserPage.owner_user_id || this.currentUser.admin || (this.fundraiser && this.fundraiser.owner_user_id === this.currentUser.id)))
    },
    fundraiser() {
      return useFundraiserPublicStore().getItemById(this.fundraiserPage.fundraiser_id)
    }
  },
  methods: { useFundraiserPagePublicStore }
}
</script>

<template>
  <div class="bg-white py-4">
    <tw-container class="max-w-[1360px]">
      <tw-transition-container>
        <tw-card v-if="!fundraiserPage.published" class="shadow-none bg-amber-100 mb-5 flex flex-col md:flex-row gap-5 justify-between md:items-center w-full">
          <p>This fundraiser is not published yet. It will not be visible to the public until you publish it. Only you can see it for now. </p>
          <span>
            <tw-button icon="pencil" class="mr-2" :to="{name: 'FundraiserPageDetailsPage', params: {fundraiserPageId: fundraiserPage.id} }" variant="secondary"> Edit </tw-button>
            <fundraiser-page-publish-button :fundraiser-page="fundraiserPage" @published="useFundraiserPagePublicStore().itemPatchState($event)" /></span>
        </tw-card>
      </tw-transition-container>
      <div class="flex justify-between items-center gap-4">
        <div v-if="fundraiserPage.logo_url && fundraiserPage">
          <router-link :to="{name: 'FundraiserPublicPage', params: {fundraiserId: fundraiserPage.fundraiser_id, slug: fundraiserPage.slug}}">
            <img :src="fundraiserPage.logo_url" class="max-h-12 md:max-h-14 max-w-[320px] md:max-w-auto" :alt="fundraiserPage.title + ' logo'">
          </router-link>
        </div>
        <div v-if="fundraiserPageEditableByCurrentUser">
          <tw-button icon="pencil" :to="{name: 'FundraiserPageDetailsPage', params: {fundraiserPageId: fundraiserPage.id} }" variant="secondary">
            Edit
          </tw-button>
        </div>
        <div v-else-if="!currentUser">
          <tw-button :to="{name: 'Login'}" variant="secondary">
            Login
          </tw-button>
        </div>
      </div>
    </tw-container>
  </div>
</template>

<style scoped>

</style>
